import { z } from 'zod';
import type { TableEditItem } from '@/components/table/table-edit/types';
import type { PartialUndefinedOrNull } from '@/types/partial';
import { ClienteFiscalPerfil } from '@/features/cliente/types/enum';
import { DestinoNotaFiscal } from '@/features/fiscal/enum/DestinoNotaFiscal';
import { DevolucaoOperacao } from '@/features/fiscal/enum/DevolucaoOperacao';
import { TipoCliente } from '@/features/fiscal/enum/TipoCliente';
import { NotaFiscalTipo } from '@/features/nfe/types/enum';

export const RegraFiscalInformacoesSchema = z.object({
    rin_destino: z.enum(DestinoNotaFiscal).nullable(),
    rin_devolucao_operacao: z.enum(DevolucaoOperacao).nullable(),
    rin_empresa_idpk: z.number(),
    rin_estado_especifico: z.string().nullable(),
    rin_idpk: z.number(),
    rin_informacoes: z.string().nullable(),
    rin_motivo: z.number().nullable(),
    rin_perfil_cliente: z.enum(ClienteFiscalPerfil),
    rin_regra_fiscal_idpk: z.number(),
    rin_tipo: z.enum(NotaFiscalTipo).nullable(),
    rin_tipo_cliente: z.enum(TipoCliente).nullable(),
    rin_todos_estados: z
        .enum(['S', 'N', ''])
        .nullable()
        .transform((v) => (v === '' ? null : v)),
});

type RegraFiscalInformacoes = z.infer<typeof RegraFiscalInformacoesSchema>;

export type RegraFiscalInformacoesBody = PartialUndefinedOrNull<RegraFiscalInformacoes> &
    TableEditItem;
